/* All menu levels, bound and fallback. Native details remain available for touch/keyboard. */
(() => {
  const key = 'akiraMenuHoverInstalled';
  if (window[key]) return;
  window[key] = true;
  const selector = 'details[data-akira-menu-branch]';
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  // Small layout gaps must be removed in CSS. This grace period tolerates a
  // continuous pointer crossing between a trigger and its descendant panel.
  const closeDelay = 300;
  const pending = new Map();
  const parentBranch = branch => branch.parentElement?.parentElement?.closest(selector);
  const cancelClose = branch => {
    const timer = pending.get(branch);
    if (timer !== undefined) clearTimeout(timer);
    pending.delete(branch);
  };
  const closeBranch = branch => {
    cancelClose(branch);
    branch.querySelectorAll(selector).forEach(node => { cancelClose(node); node.open = false; });
    branch.open = false;
  };
  const keepPath = target => {
    let branch = target?.closest?.(selector);
    while (branch) { cancelClose(branch); branch = parentBranch(branch); }
  };
  const queueClose = branch => {
    cancelClose(branch);
    const timer = setTimeout(() => {
      if (pending.get(branch) !== timer) return;
      pending.delete(branch);
      if (branch.isConnected && !branch.matches(':hover')) closeBranch(branch);
    }, closeDelay);
    pending.set(branch, timer);
  };
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    let branch = event.target.closest?.(selector);
    while (branch) {
      cancelClose(branch);
      const item = branch.parentElement;
      for (const sibling of item.parentElement.children) {
        if (sibling !== item) sibling.querySelectorAll(selector).forEach(closeBranch);
      }
      branch.open = true;
      branch = parentBranch(branch);
    }
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    let branch = event.target.closest?.(selector);
    while (branch) {
      if (event.relatedTarget instanceof Node && branch.contains(event.relatedTarget)) break;
      queueClose(branch);
      branch = parentBranch(branch);
    }
  });
  document.addEventListener('focusin', event => keepPath(event.target));
  document.addEventListener('pointerdown', event => keepPath(event.target));
  // Wait until the click target is fixed. Closing a tall mobile branch during
  // pointerdown can clamp the scroll position and move the pointerup target.
  document.addEventListener('click', event => {
    keepPath(event.target);
    document.querySelectorAll(selector + '[open]').forEach(branch => {
      if (!branch.contains(event.target)) closeBranch(branch);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') keepPath(event.target);
    if (event.key !== 'Escape') return;
    const branch = event.target.closest?.(selector);
    if (!branch) {
      document.querySelectorAll(selector + '[open]').forEach(closeBranch);
      return;
    }
    keepPath(event.target);
    closeBranch(branch);
    branch.querySelector('summary')?.focus();
    event.preventDefault();
    event.stopPropagation();
  });
  desktop.addEventListener('change', () => {
    pending.forEach(timer => clearTimeout(timer));
    pending.clear();
  });
})();
